import { render, staticRenderFns } from "./FollowingProductionOrderView.vue?vue&type=template&id=736d7980&scoped=true&"
import script from "./FollowingProductionOrderView.vue?vue&type=script&lang=js&"
export * from "./FollowingProductionOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736d7980",
  null
  
)

export default component.exports